import React from 'react';

export const MainPage = () => {
    return (
        <div className='main-page'>
            <div className="sign">
                Don't&nbsp;
            <span className="fast-flicker">w
            </span>orry
            <span className="flicker">
                    <br />
            be</span>
            happy
        </div>
            <div className='just-me'>Hi, I'm just Dana and this is my 18-en HW for Cursor</div>
        </div>
    )
}